<template>
  <div id="backdoor">
    <div
      v-loading="isLoading"
      class="main"
    >
      <div class="title_bar">
        <div class="left">
          <div class="title">
            BA 告警模擬
          </div>
          <div class="tip">
            僅 dev / staging 可用。透過 dev / staging 告警後端觸發或結案公區告警事件
          </div>
        </div>
      </div>
      <p>目前僅支援後臺測試社區</p>
      <br>
      <p><a href="https://kingnetrd.visualstudio.com/RD-ProjectWorkItem/_wiki/wikis/RD-ProjectWorkItem.wiki/1592/BA-%E5%91%8A%E8%AD%A6%E7%B3%BB%E7%B5%B1">參考文件 - 明展所開發的 windows 工具，資料為 hard code，近年無更新</a></p>
      <br>
      <el-button
        @click="mockBulkRecord('dev', true, baTagData)"
      >
        結案所有 dev
      </el-button>
      <el-button
        @click="mockBulkRecord('staging', true, baTagData)"
      >
        結案所有 staging
      </el-button>
      <el-button
        @click="showOwnerReportDialog"
      >
        dev - 強制結案雲端室內機
      </el-button>
      <el-button
        @click="showRepublishDialog"
      >
        dev - 重新發送推播
      </el-button>
      <br>
      <br>
      <el-table
        class="TagList"
        :data="baTagData"
        empty-text="目前無任何公告"
      >
        <el-table-column
          prop="Tag.Id"
          label="Id"
        >
        </el-table-column>
        <el-table-column
          prop="Level"
          label="等級"
        >
        </el-table-column>ㄒ
        <el-table-column
          prop="Tag.Name"
          label="點位名稱"
        >
        </el-table-column>
        <el-table-column
          prop="Message"
          label="點位訊息"
        >
        </el-table-column>
        <el-table-column
          prop="FENote"
          label="備註"
        >
        </el-table-column>
        <el-table-column
          label="dev"
        >
          <template slot-scope="scope">
            <el-button size="small" type="danger" plain @click="createNewEvent('dev', scope.row)">
              dev 觸發事件
            </el-button>
            <br>
            <el-button size="small" type="primary" plain @click="finishEvent('dev', scope.row)">
              dev 結案
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="staging"
        >
          <template slot-scope="scope">
            <el-button size="small" type="danger" plain @click="createNewEvent('staging', scope.row)">
              staging 觸發事件
            </el-button>
            <br>
            <el-button size="small" type="primary" plain @click="finishEvent('staging', scope.row)">
              staging 結案
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 內容寫這 -->
    </div>

    <!-- 雲端室內機結案對話框 -->
    <el-dialog
      title="強制結案 dev 雲端室內機"
      :visible.sync="ownerReportDialogVisible"
      width="30%"
    >
      <el-form
        ref="ownerReportForm"
        :model="ownerReportForm"
        :rules="ownerReportRules"
        label-width="100px"
      >
        <el-form-item label="戶別 id" prop="tabletId">
          <el-input v-model="ownerReportForm.tabletId" placeholder="請輸入戶別 id"></el-input>
        </el-form-item>
        <el-form-item label="結案者" prop="reporter">
          <el-input v-model="ownerReportForm.reporter" placeholder="請輸入結案者"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ownerReportDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="ownerReportSubmitting" @click="submitOwnerReport">確定</el-button>
      </span>
    </el-dialog>

    <!-- 重新發送推播對話框 -->
    <el-dialog
      title="重新發送推播"
      :visible.sync="republishDialogVisible"
      width="500px"
    >
      <el-form
        ref="republishForm"
        :model="republishForm"
        :rules="republishRules"
        label-width="100px"
      >
        <el-form-item label="EventIds" prop="eventIds">
          <el-input
            v-model="republishForm.eventIds"
            type="textarea"
            :rows="4"
            placeholder="請輸入 EventIds，若有多筆請用逗號隔開"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="republishDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="republishSubmitting" @click="submitRepublishNotification">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baTagData } from '@/js/utils/mockBaNotification.js'
export default {
  components: {

  },
  data () {
    return {
      isLoading: true,
      tags: null,
      baTagData,
      // 雲端室內機結案相關數據
      ownerReportDialogVisible: false,
      ownerReportForm: {
        tabletId: '',
        reporter: ''
      },
      ownerReportRules: {
        tabletId: [
          { required: true, message: '請輸入 TabletId', trigger: 'blur' }
        ],
        reporter: [
          { required: true, message: '請輸入 Reporter', trigger: 'blur' }
        ]
      },
      ownerReportSubmitting: false,
      // 重新發送推播相關數據
      republishDialogVisible: false,
      republishForm: {
        eventIds: ''
      },
      republishRules: {
        eventIds: [
          { required: true, message: '請輸入 EventIds', trigger: 'blur' }
        ]
      },
      republishSubmitting: false
    }
  },
  async mounted () {
    try {
      // 取得 dev tags
      const tagsRes = await apiBaAlertSource.getTags()
      const tagsData = tagsRes.data
      const tagLevel = [
        'Normal',
        'Low',
        'Medium',
        'High',
        'Disaster'
      ]
      this.tags = [
        [],
        [],
        [],
        [],
        []
      ]
      tagsData.forEach(el => {
        const level = tagLevel.indexOf(el.Level)
        this.tags[level].push(el.TagId)
      })
    } catch (error) {

    } finally {
      this.isLoading = false
    }
  },
  methods: {
    // 顯示雲端室內機結案對話框
    showOwnerReportDialog () {
      this.ownerReportDialogVisible = true
      // 重設表單
      if (this.$refs.ownerReportForm) {
        this.$refs.ownerReportForm.resetFields()
      }
    },
    // 提交強制結案 dev 雲端室內機請求
    async submitOwnerReport () {
      try {
        // 表單驗證
        await this.$refs.ownerReportForm.validate()
        this.ownerReportSubmitting = true
        const url = 'https://alarm-dev.kingnetsmart.com.tw/api/Event/Private/OwnerReport'
        const data = {
          TabletId: this.ownerReportForm.tabletId,
          Reporter: this.ownerReportForm.reporter
        }
        const config = {
          headers: {
            'x-comid': 16051001,
            authenticationscheme: 'ApiKeyAuthenticationHandler',
            authorization: '41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE',
            'content-type': 'application/json'
          }
        }
        // 發送請求
        await axios.post(url, data, config)
        // 處理成功
        this.$message({
          message: '強制結案 dev 雲端室內機成功',
          type: 'success'
        })
        // 關閉對話框
        this.ownerReportDialogVisible = false
      } catch (error) {
        // 處理錯誤
        let errorMessage = '強制結案 dev 雲端室內機失敗'
        if (error.response && error.response.data) {
          errorMessage += `: ${error.response.data.message || JSON.stringify(error.response.data)}`
        }
        this.$message({
          message: errorMessage,
          type: 'error'
        })
        console.error('強制結案 dev 雲端室內機失敗:', error)
      } finally {
        this.ownerReportSubmitting = false
      }
    },
    // 顯示重新發送推播對話框
    showRepublishDialog () {
      this.republishDialogVisible = true
      // 重設表單
      if (this.$refs.republishForm) {
        this.$refs.republishForm.resetFields()
      }
    },
    // 提交重新發送推播請求
    async submitRepublishNotification () {
      try {
        // 表單驗證
        await this.$refs.republishForm.validate()
        this.republishSubmitting = true
        // 處理 EventIds，將字串轉為陣列
        const eventIdsArray = this.republishForm.eventIds
          .split(',')
          .map(id => id.trim())
          .filter(id => id !== '')
        const url = 'https://alarm-dev.kingnetsmart.com.tw/api/Event/RePublishNotification'
        const data = {
          EventIds: eventIdsArray
        }
        const config = {
          headers: {
            'x-comid': 16051001,
            authenticationscheme: 'ApiKeyAuthenticationHandler',
            authorization: '41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE',
            'content-type': 'application/json'
          }
        }
        // 發送請求
        await axios.post(url, data, config)
        // 處理成功
        this.$message({
          message: '重新發送推播成功',
          type: 'success'
        })
        // 關閉對話框
        this.republishDialogVisible = false
      } catch (error) {
        // 處理錯誤
        let errorMessage = '重新發送推播失敗'
        if (error.response && error.response.data) {
          errorMessage += `: ${error.response.data.message || JSON.stringify(error.response.data)}`
        }
        this.$message({
          message: errorMessage,
          type: 'error'
        })
        console.error('重新發送推播失敗:', error)
      } finally {
        this.republishSubmitting = false
      }
    },
    async mockRecord (env, status, data) {
      function uuidv4 () { // Public Domain/MIT
        let d = new Date().getTime()// Timestamp
        let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0// Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = Math.random() * 16// random number between 0 and 16
          if (d > 0) { // Use timestamp until depleted
            r = (d + r) % 16 | 0
            d = Math.floor(d / 16)
          } else { // Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0
            d2 = Math.floor(d2 / 16)
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
      }
      const warningTime = new Date().toISOString()
      const url = `https://alarm-${env}.kingnetsmart.com.tw/api/Log/Record`
      const config = {
        headers: {
          'x-comid': 16051001,
          authenticationscheme: 'ApiKeyAuthenticationHandler',
          authorization: '41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE'
        }
      }
      const newData = {
        ...data,
        WarningTime: warningTime,
        WarningId: uuidv4(),
        Status: status
      }
      try {
        await axios.post(url, newData, config)
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async createNewEvent (env, data) {
      try {
        await this.mockRecord(env, true, data)
        await this.$sleep(300)
        await this.mockRecord(env, false, data)
        this.$message({
          message: '觸發成功',
          type: 'success'
        })
      } catch (error) {
        console.error(error)
        this.$message({
          message: '觸發失敗',
          type: 'error'
        })
      }
    },
    async finishEvent (env, data) {
      try {
        await this.mockRecord(env, true, data)
        this.$message({
          message: '結案成功',
          type: 'success'
        })
      } catch (error) {
        console.error(error)
        this.$message({
          message: '結案失敗',
          type: 'error'
        })
      }
    },
    async mockBulkRecord (env, status, data) {
      function uuidv4 () { // Public Domain/MIT
        let d = new Date().getTime()// Timestamp
        let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0// Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = Math.random() * 16// random number between 0 and 16
          if (d > 0) { // Use timestamp until depleted
            r = (d + r) % 16 | 0
            d = Math.floor(d / 16)
          } else { // Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0
            d2 = Math.floor(d2 / 16)
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
      }
      const warningTime = new Date().toISOString()
      const url = `https://alarm-${env}.kingnetsmart.com.tw/api/Log/BulkRecord`
      const config = {
        headers: {
          'x-comid': 16051001,
          authenticationscheme: 'ApiKeyAuthenticationHandler',
          authorization: '41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE'
        }
      }
      const newData = data.map(el => {
        return {
          ...el,
          WarningTime: warningTime,
          WarningId: uuidv4(),
          Status: status
        }
      })
      try {
        axios.post(url, newData, config)
        this.$message({
          message: status ? '結案成功' : '觸發成功',
          type: 'success'
        })
      } catch (error) {
        console.log(error)
      }
    },
    async finishAllUnfinishedEventDev () {
      try {
        const unfinishedEventRes = await apiBaAlert.getUnfinishedEvent()
        const unfinishedEventData = unfinishedEventRes.data
        if (!unfinishedEventData || unfinishedEventData.length === 0) return
        const unfinishedEventIdArr = unfinishedEventData.map(el => el.EventId)
        for (let index = 0; index < unfinishedEventIdArr.length; index++) {
          const element = unfinishedEventIdArr[index]
          await apiBaAlert.reportEvent(element, {
            stageType: 2,
            remark: '開發人員批量結案'
          })
        }
        this.$message({
          message: '批量結案成功',
          type: 'success'
        })
      } catch (error) {
        console.log(error)
      }
    },
    async mockAllLevelStaging (status) {
      function uuidv4 () { // Public Domain/MIT
        let d = new Date().getTime()// Timestamp
        let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0// Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = Math.random() * 16// random number between 0 and 16
          if (d > 0) { // Use timestamp until depleted
            r = (d + r) % 16 | 0
            d = Math.floor(d / 16)
          } else { // Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0
            d2 = Math.floor(d2 / 16)
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
      }
      const warningTime = new Date().toISOString()
      const message = status ? '正常' : '異常'
      const url = 'https://alarm-staging.kingnetsmart.com.tw/api/Log/BulkRecord'
      const data = [
        {
          WarningTime: warningTime,
          WarningId: uuidv4(),
          AutoTrigger: 0,
          Level: 1,
          Tag: { Id: 'BUOU-10-6-DI-1', Name: '車位押扣', Value: '0', Unit: '警報' },
          Device: { Id: 'BUOU-10-6-DI-1', Name: '車位押扣', Type: '緊急' },
          Location: 'A棟B1公區',
          Status: status,
          Message: message,
          Remark: '',
          OriginalData: {}
        },
        {
          WarningTime: warningTime,
          WarningId: uuidv4(),
          AutoTrigger: 0,
          Level: 2,
          Tag: { Id: 'BUOU-10-6-DI-3', Name: '電信室磁簧', Value: '0', Unit: '警報' },
          Device: { Id: 'BUOU-10-6-DI-3', Name: '電信室磁簧', Type: '緊急' },
          Location: 'A棟B1公區',
          Status: status,
          Message: message,
          Remark: '',
          OriginalData: {}
        },
        {
          WarningTime: warningTime,
          WarningId: uuidv4(),
          AutoTrigger: 0,
          Level: 3,
          Tag: {
            Id: 'BUOU-10-6-DI-4',
            Name: '油壓機房磁簧',
            Value: '0',
            Unit: '警報'
          },
          Device: { Id: 'BUOU-10-6-DI-4', Name: '油壓機房磁簧', Type: '緊急' },
          Location: 'A棟B1公區',
          Status: status,
          Message: message,
          Remark: '',
          OriginalData: {}
        },
        {
          WarningTime: warningTime,
          WarningId: uuidv4(),
          AutoTrigger: 0,
          Level: 4,
          Tag: { Id: 'BUOU-10-6-UI-7', Name: '電器室磁簧', Value: '0', Unit: '警報' },
          Device: { Id: 'BUOU-10-6-UI-7', Name: '電器室磁簧', Type: '緊急' },
          Location: 'A棟B1公區',
          Status: status,
          Message: message,
          Remark: '',
          OriginalData: {}
        }
      ]
      const config = {
        headers: {
          'x-comid': 16051001,
          authenticationscheme: 'ApiKeyAuthenticationHandler',
          authorization: '41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE'
        }
      }
      try {
        axios.post(url, data, config)
        this.$message({
          message: status ? '批量結案成功' : '觸發所有等級之事件成功',
          type: 'success'
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#backdoor {
  @include mainLayer();
  ::v-deep .el-table{
    @include basicTable();
  }
  .title {
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 10px;
    text-align: left;
  }
}
</style>
